module.exports = __webpack_public_path__ + "static/media/top-img_16@2x.be36c235.png";